const heroSearch = () => ({
  productsBrowserData: null,

  get title() {
    const { productsBrowserData } = this;

    if (!productsBrowserData) return '';

    const { pagination, query } = productsBrowserData.data;

    const q = query?.corrected || productsBrowserData.searchParams.get('q');

    const s = pagination.totalResults > 1 ? 's' : '';
    return `Showing ${pagination.totalResults} result${s} for "${q}"`;
  },

  get didYouMeanData() {
    const { productsBrowserData } = this;

    if (!productsBrowserData?.data?.didYouMean) return null;

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('q', productsBrowserData.data.didYouMean.query);

    return {
      url: newUrl.toString(),
      query: productsBrowserData.data.didYouMean.query,
    };
  },
});

export default heroSearch;
